import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { CommonService } from "../../Service/CommonService";
import { InventoryApiService } from "../../Service/InventoryApiService";
import "../Dynamic/UserList.scss";

const ViewContractPricingDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const [contractPricing, setContractPricing] = useState<any>();

  useEffect(() => {
    getContractPricingDetails();
  }, []);

  const getContractPricingDetails = async () => {
    try {
      const response = await InventoryApiService.getContractPricingDetailsById(id);
      setContractPricing(response.data);
    } catch (error) {
      console.log("error occurred while fetching the contract detail");
    }
  };

  const routeBack = () => {
    history.goBack();
  };

  return (
    <>
      <div className="usersList position-relative">
        <div className="usersList__header--wrapper d-flex flex-wrap justify-content-between align-items-center">
          <div className="d-flex flex-wrap justify-content-between gap-4">
            {CommonService.isAdmin() && (
              <div className="d-flex align-items-center gap-1">
                <>
                  <div className="back__button me-1" onClick={routeBack}>
                    <IconButton
                      aria-label="ArrowBackIcon"
                      sx={{ backgroundColor: "#FFF" }}
                    >
                      <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                    </IconButton>
                  </div>
                  <div className="header--title me-3">
                    <h1 className="title mb-0">
                      Contract Pricing Details
                      <i className="bi bi-heart-fill"></i>
                    </h1>
                  </div>
                </>
              </div>
            )}
        
          </div>
        </div>
        <div className="viewSampleRequest--wrapper view_request--wrapper view_sample-wrapper viewOrderRequest--wrapper viewServiceRequest--wrapper viewSupport-req inventory-listing-detail view-contract-detail">
          <div className="no-margin w-100">
            <div className="view-sample-request m-0">
              <div className="row m-0">
                <div className="col-12 px-0">
                  <div
                    className="inventory-file-list-table"
                    style={{ minHeight: "calc(100vh - 175px)" }}
                  >
                    <div className="right-wrapper border-0">
                      <div className="row m-0">
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">Pricing Type</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contractPricing?.type}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">Date</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {CommonService.formatDateToReadableString(contractPricing?.date) || '-'}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">Put Away Cost</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contractPricing?.putAway ? `$${contractPricing.putAway}` : '-'}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">Storage Cost Per Barrel</p>
                            <div className="title-bottom-line"></div>
                            <div className="content-text">
                              {contractPricing?.barrelStorage ? `$${contractPricing.barrelStorage}` : '-'}
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">Storage Cost Per Pallet</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contractPricing?.palletStorage ? `$${contractPricing.palletStorage}` : '-'}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">Storage Cost Per Tote</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                                {contractPricing?.toteStorage ? `$${contractPricing.toteStorage}` : '-'}
                            </p>
                          </div>    
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">Retrieval Cost Per Barrel</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                                {contractPricing?.retrieval ? `$${contractPricing.retrieval}` : '-'}
                            </p>
                          </div>
                        </div>
                    
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">
                              Barrel Emptying Cost Per Hour
                            </p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contractPricing?.barrelEmptying ? `$${contractPricing.barrelEmptying}` : '-'}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">
                              Re-Barreling Cost Per Hour
                            </p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                                {contractPricing?.reBarreling ? `$${contractPricing.reBarreling}` : '-'}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper">
                            <p className="content-title">
                              4-Barrels Pallets For Shipping Per Hour
                            </p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contractPricing?.fourBarrelsPalletsForShipping ? `$${contractPricing.fourBarrelsPalletsForShipping}` : '-'}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">
                                6-Barrels Pallets For Shipping Per Hour
                            </p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contractPricing?.sixBarrelsPalletsForShipping ? `$${contractPricing.sixBarrelsPalletsForShipping}` : '-'}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">Physical Inventory</p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                               {contractPricing?.physicalInventory ? `$${contractPricing.physicalInventory}` : '-'}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">
                              Sample Pulled From Customer Barrels
                            </p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contractPricing?.samplePulledFromCustomerBarrels ? `$${contractPricing.samplePulledFromCustomerBarrels}` : '-'}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">
                              Ownership Transfer
                            </p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contractPricing?.ownershipTransfer ? `$${contractPricing.ownershipTransfer}` : '-'}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
                          <div className="content-wrapper cursor-pointer">
                            <p className="content-title">
                             Any Additional Service Requested
                            </p>
                            <div className="title-bottom-line"></div>
                            <p className="content-text">
                              {contractPricing?.anyAdditionalServiceRequested ? `$${contractPricing.anyAdditionalServiceRequested}` : '-'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewContractPricingDetails;
